import type { PrimeVuePTOptions } from 'primevue/config';
import { usePassThrough } from 'primevue/passthrough';
import Tailwind from 'primevue/passthrough/tailwind';

import { AvatarDesign } from '@/design-system/avatar.design';
import { AccordionDesign, AccordionTabDesign } from './accordion.design';
import { ChipDesign } from './chip.design';
import { DataTableDesign } from './datatable.design';
import { DropdownDesign } from './dropdown.design';
import { MenuDesign } from './menu.design';
import { MenubarDesign } from './menubar.design';
import { OverlayPanelDesign } from './overlay-panel.design';
import { TabMenuDesign } from './tab-menu.design';

const CustomDesign = {
    ...ChipDesign,
    ...DropdownDesign,
    ...MenuDesign,
    ...MenubarDesign,
    ...DataTableDesign,
    ...AccordionDesign,
    ...AccordionTabDesign,
    ...TabMenuDesign,
    ...AvatarDesign,
    ...OverlayPanelDesign,
} as PrimeVuePTOptions;

export const ClosinglockDesignSystem = usePassThrough(Tailwind, CustomDesign, { mergeProps: false, mergeSections: true });
